/**
 * Revenue Flow preview for scrollytelling — real app blocks with fixture data, no interactions.
 */

import * as React from "react";
import { DemoErrorBoundary } from "@/components/landing/demos/DemoErrorBoundary";
import { InPlayBlock } from "@/components/pipeline/InPlayBlock";
import { WonBlock } from "@/components/pipeline/WonBlock";
import { LostBlock } from "@/components/pipeline/LostBlock";
import { mockDeals, mockLeads } from "@/components/landing/previews/mockPipelineData";

const noop = () => {};

export function RevenueFlowPreview() {
  return (
    <div className="pointer-events-none select-none min-h-[340px] w-full">
      <DemoErrorBoundary>
        <div className="space-y-5 p-3 dark">
          <InPlayBlock
            deals={mockDeals}
            leads={mockLeads}
            onCall={noop}
            onWhatsApp={noop}
            onSendToPhone={noop}
            onCardClick={noop}
            onMarkWon={noop}
            onMarkLost={noop}
            onReschedule={noop}
          />
          <WonBlock deals={mockDeals} leads={mockLeads} />
          <LostBlock deals={mockDeals} leads={mockLeads} />
        </div>
      </DemoErrorBoundary>
    </div>
  );
}
